export const hasSelectedOptions = (options, currentValue) => {
    let selected = 0;
    if (Array.isArray(currentValue)) {
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.map((selectedOption) => {
            options.map((option) => {
                // only check input value
                if (selectedOption && option && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === (option === null || option === void 0 ? void 0 : option.value)) {
                    selected++;
                }
            });
        });
        return selected === 0 ? false : selected === options.length ? true : undefined;
    }
    return false;
};
export const isOptionSelected = (option, value) => {
    let selected = false;
    if (Array.isArray(value)) {
        value.map((key) => {
            if (typeof key === 'string' && option === key) {
                selected = true;
            }
            else if ((option === null || option === void 0 ? void 0 : option.value) && (option === null || option === void 0 ? void 0 : option.value) === (key === null || key === void 0 ? void 0 : key.value)) {
                selected = true;
            }
            return false;
        });
        return selected;
    }
    else {
        return option === value;
    }
};
export const calculateSelectedIndexes = (options, value) => {
    const selectedValues = value === undefined || value === '' ? [] : !Array.isArray(value) ? [value] : value;
    const validateSelection = (option) => {
        var _a, _b, _c, _d;
        if (typeof option !== 'string' && (option === null || option === void 0 ? void 0 : option.options)) {
            // walk through sub options if they are selected to indicate the group selection (based on input-value only)
            result[(_b = (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : option === null || option === void 0 ? void 0 : option.label) !== null && _b !== void 0 ? _b : option] = hasSelectedOptions(option === null || option === void 0 ? void 0 : option.options, value);
            // gather sub options
            option.options.map(validateSelection);
        }
        else {
            const item = option;
            if (value &&
                selectedValues.find((value) => typeof value === 'string' ? value === option : (value === null || value === void 0 ? void 0 : value.value) === (item === null || item === void 0 ? void 0 : item.value))) {
                result[(_c = item === null || item === void 0 ? void 0 : item.value) !== null && _c !== void 0 ? _c : option] = true;
            }
            else {
                result[(_d = item === null || item === void 0 ? void 0 : item.value) !== null && _d !== void 0 ? _d : option] = false;
            }
        }
    };
    const result = {};
    options === null || options === void 0 ? void 0 : options.map(validateSelection);
    return result;
};
